/* eslint-disable */
// source: vivacity/core/hardware_heartbeat.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

goog.exportSymbol('proto.vivacity.core.HardwareHeartbeat', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.vivacity.core.HardwareHeartbeat = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.vivacity.core.HardwareHeartbeat, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.vivacity.core.HardwareHeartbeat.displayName = 'proto.vivacity.core.HardwareHeartbeat';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.vivacity.core.HardwareHeartbeat.prototype.toObject = function(opt_includeInstance) {
  return proto.vivacity.core.HardwareHeartbeat.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.vivacity.core.HardwareHeartbeat} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vivacity.core.HardwareHeartbeat.toObject = function(includeInstance, msg) {
  var f, obj = {
    hardwareId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    percentageCharge: jspb.Message.getFieldWithDefault(msg, 2, 0),
    timestampMicro: jspb.Message.getFieldWithDefault(msg, 3, 0),
    externalPowerLost: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
    noInternet: jspb.Message.getBooleanFieldWithDefault(msg, 5, false),
    startup: jspb.Message.getBooleanFieldWithDefault(msg, 6, false),
    remoteAddress: jspb.Message.getFieldWithDefault(msg, 7, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.vivacity.core.HardwareHeartbeat}
 */
proto.vivacity.core.HardwareHeartbeat.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.vivacity.core.HardwareHeartbeat;
  return proto.vivacity.core.HardwareHeartbeat.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.vivacity.core.HardwareHeartbeat} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.vivacity.core.HardwareHeartbeat}
 */
proto.vivacity.core.HardwareHeartbeat.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setHardwareId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setPercentageCharge(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setTimestampMicro(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setExternalPowerLost(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setNoInternet(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setStartup(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setRemoteAddress(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.vivacity.core.HardwareHeartbeat.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.vivacity.core.HardwareHeartbeat.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.vivacity.core.HardwareHeartbeat} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.vivacity.core.HardwareHeartbeat.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getHardwareId();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getPercentageCharge();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getTimestampMicro();
  if (f !== 0) {
    writer.writeUint64(
      3,
      f
    );
  }
  f = message.getExternalPowerLost();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getNoInternet();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
  f = message.getStartup();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
  f = message.getRemoteAddress();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
};


/**
 * optional uint32 hardware_id = 1;
 * @return {number}
 */
proto.vivacity.core.HardwareHeartbeat.prototype.getHardwareId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.vivacity.core.HardwareHeartbeat} returns this
 */
proto.vivacity.core.HardwareHeartbeat.prototype.setHardwareId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 percentage_charge = 2;
 * @return {number}
 */
proto.vivacity.core.HardwareHeartbeat.prototype.getPercentageCharge = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.vivacity.core.HardwareHeartbeat} returns this
 */
proto.vivacity.core.HardwareHeartbeat.prototype.setPercentageCharge = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional uint64 timestamp_micro = 3;
 * @return {number}
 */
proto.vivacity.core.HardwareHeartbeat.prototype.getTimestampMicro = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.vivacity.core.HardwareHeartbeat} returns this
 */
proto.vivacity.core.HardwareHeartbeat.prototype.setTimestampMicro = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional bool external_power_lost = 4;
 * @return {boolean}
 */
proto.vivacity.core.HardwareHeartbeat.prototype.getExternalPowerLost = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.vivacity.core.HardwareHeartbeat} returns this
 */
proto.vivacity.core.HardwareHeartbeat.prototype.setExternalPowerLost = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * optional bool no_internet = 5;
 * @return {boolean}
 */
proto.vivacity.core.HardwareHeartbeat.prototype.getNoInternet = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.vivacity.core.HardwareHeartbeat} returns this
 */
proto.vivacity.core.HardwareHeartbeat.prototype.setNoInternet = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};


/**
 * optional bool startup = 6;
 * @return {boolean}
 */
proto.vivacity.core.HardwareHeartbeat.prototype.getStartup = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.vivacity.core.HardwareHeartbeat} returns this
 */
proto.vivacity.core.HardwareHeartbeat.prototype.setStartup = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};


/**
 * optional string remote_address = 7;
 * @return {string}
 */
proto.vivacity.core.HardwareHeartbeat.prototype.getRemoteAddress = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.vivacity.core.HardwareHeartbeat} returns this
 */
proto.vivacity.core.HardwareHeartbeat.prototype.setRemoteAddress = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


goog.object.extend(exports, proto.vivacity.core);
